import styles from "./Footer.module.scss";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const Footer = () => {
  const { t } = useTranslation();

  return (
    <div className={styles.footer}>
      <div className="container">
        <div className={styles.wrapper}>
          <div className={styles.option}>
            <h3 className={styles.naming}>{t("Company")}</h3>
            <ul className={styles.list}>
              <li>
                <Link className={styles.link} to={""}>
                  {t("AboutUs")}
                </Link>
              </li>
              <li>
                <Link className={styles.link} to={""}>
                  {t("Plans")}
                </Link>
              </li>
              <li>
                <Link className={styles.link} to={""}>
                  {t("HowItWorks")}
                </Link>
              </li>
              {/*<li>*/}
              {/*    <Link className={styles.link} to={""}>Referral program</Link>*/}
              {/*</li>*/}
            </ul>
          </div>
          <div className={styles.option}>
            <h3 className={styles.naming}>{t("Support")}</h3>
            <ul className={styles.list}>
              <li>
                <Link className={styles.link} to={""}>
                  {t("ContactUs")}
                </Link>
              </li>
              <li>
                <Link className={styles.link} to={""}>
                  {t("HelpCenter")}
                </Link>
              </li>
            </ul>
          </div>
          <div className={styles.option}>
            <h3 className={styles.naming}>{t("Community")}</h3>
            <ul className={styles.list}>
              {/*<li>*/}
              {/*    <Link className={styles.link} to={""}>Refer a friend</Link>*/}
              {/*</li>*/}
              <li>
                <Link className={styles.link} to={"/blog"}>
                  {t("Blog")}
                </Link>
              </li>
              <li>
                <Link className={styles.link} to={""}>
                  {t("Locations")}
                </Link>
              </li>
              {/*<li>*/}
              {/*    <Link className={styles.link} to={""}>Referral program</Link>*/}
              {/*</li>*/}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
